import { render, staticRenderFns } from "./avatarConfig.vue?vue&type=template&id=4caf52f6"
import script from "./avatarConfig.vue?vue&type=script&lang=js"
export * from "./avatarConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports